import { useTranslation } from "react-i18next";
import { useStorageObject } from "../../app/state/storageObjectSlice/hook/use-storage-object";
import { useServiceNavigate } from "../../app/state/storageObjectSlice/hook/use-service-navigate";
import { Sidebar } from "../../common/AppSidebar";
import { SafeOutlet } from "../../common/Protectors/SafeOutlet";
import styles from "./styles.module.css";
import { useStorageSelectors } from "../../app/state/storageObjectSlice/hook/use-storage-selectors";

export const ResearchPage = () => {
  const { menuItems, selectedObject, isLoading, currentService } =
    useStorageSelectors("research");
  const { addObject, handleSelectObject } = useStorageObject(
    "research",
    "research",
    currentService,
  );
  const { t } = useTranslation();

  useServiceNavigate("research", "research");

  return (
    <div className={styles["page-layout"]}>
      <Sidebar
        menuItems={menuItems}
        onAdd={() => addObject(t("research.default_name"), "child")}
        onSelect={handleSelectObject}
        selectedId={selectedObject?.id ?? ""}
        service={"research"}
        isLoading={isLoading ?? false}
      />
      {selectedObject && <SafeOutlet />}
    </div>
  );
};
